/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 2707
// module chunks = 0